// import { validationRules } from './validationRules';

// export const handleFieldChange = (field, value, setDetails, setErrors) => {
//   // Update field value
//   setDetails((prev) => ({ ...prev, [field]: value }));

//   // Validate field
//   let errorMsg = '';
//   switch (field) {
//     case 'email':
//       errorMsg = validationRules.email(value);
//       break;
//     case 'phone':
//       errorMsg = validationRules.phone(value);
//       break;
//     case 'password':
//       errorMsg = validationRules.password(value);
//       break;
//     case 'pinCode':
//       errorMsg = validationRules.pinCode(value);
//       break;    
//     case 'name':
//       errorMsg = validationRules.name(value);
//       break;
//     case 'address':
//       errorMsg = validationRules.address(value);
//       break;
//     default:
//       errorMsg = '';
//   }

//   // Update error state
//   setErrors((prev) => ({ ...prev, [field]: errorMsg }));
// };



// import { validationRules } from './validationRules';

// export const handleFieldChange = (field, value, setDetails, setErrors) => {
//   // Update field value
//   setDetails((prev) => ({ ...prev, [field]: value }));

//   // Determine validator
//   const validator = validationRules[field]
//     ? (val) => validationRules[field](val)
//     : (val) => validationRules.default(val, formatFieldLabel(field));

//   // Validate and update error
//   const errorMsg = validator(value);
//   setErrors((prev) => ({ ...prev, [field]: errorMsg }));
// };

// // Optional: Format field name into readable label
// const formatFieldLabel = (field) => {
//   const map = {
//     firstName: 'First Name',
//     lastName: 'Last Name',
//     state: 'State',
//     city: 'City',
//     zip: 'ZIP Code',
//   };
//   return map[field] || field.charAt(0).toUpperCase() + field.slice(1);
// };







import { validationRules } from './validationRules';

export const handleFieldChange = (field, value, setDetails, setErrors, fieldLabel) => {
  // Update field value
  setDetails((prev) => ({ ...prev, [field]: value }));

  // Use provided label or fallback to formatted field name or raw field
  const label = fieldLabel || formatFieldLabel(field) || field;

  // Determine validator
  const validator = validationRules[field]
    ? (val) => validationRules[field](val)
    : (val) => validationRules.default(val, label);

  // Validate and update error
  const errorMsg = validator(value);
  setErrors((prev) => ({ ...prev, [field]: errorMsg }));
};

// Optional: Format field name into readable label
const formatFieldLabel = (field) => {
  const map = {
    firstName: 'First Name',
    lastName: 'Last Name',
    state: 'State',
    city: 'City',
    zip: 'ZIP Code',
    county: 'County/State',
  };
  return map[field];
};
